<template>
  <div class="message-reactions"
       :class="{ 'message-reactions--has-reactions': hasReactions }"
       v-if="hasReactions || showPicker">
    <div class="message-reactions__list">
      <reaction-bubble
        v-for="(data, emoji) in localReactionSummary"
        :key="emoji"
        :emoji="emoji"
        :count="data.count"
        :message-id="messageId"
        :has-reacted="data.hasReacted"
        :user-reaction-id="data.userReactionId"
        @reaction-added="onReactionAdded"
        @reaction-removed="onReactionRemoved"
      ></reaction-bubble>
      <reaction-picker
        v-if="showPicker"
        class="reaction-picker-anchor"
        :message-id="messageId"
        :user-reactions="userReactions"
        @reaction-added="onReactionAdded"
        @reaction-removed="onReactionRemoved"
      ></reaction-picker>
    </div>
  </div>
</template>

<script>
import ReactionBubble from './reaction_bubble.vue';
import ReactionPicker from './reaction_picker.vue';

export default {
  name: 'message-reactions',
  components: {
    ReactionBubble,
    ReactionPicker,
  },
  props: {
    messageId: {
      type: Number,
      required: true,
    },
    reactionSummary: {
      type: Object,
      default: () => ({}),
    },
    currentUserReactions: {
      type: Array,
      default: () => ([]),
    },
    showPicker: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      userReactions: {},
      localReactionSummary: {},
      initialLoadDone: false,
    };
  },
  computed: {
    hasReactions() {
      return Object.keys(this.localReactionSummary).length > 0;
    },
  },
  watch: {
    reactionSummary: {
      handler(newVal) {
        if (!this.initialLoadDone) {
          this.initializeLocalSummary(newVal);
          this.initialLoadDone = true;
        }
      },
      immediate: true,
    },
  },
  methods: {
    initializeLocalSummary(summary) {
      const newSummary = {};
      for (const [emoji, count] of Object.entries(summary || {})) {
        newSummary[emoji] = {
          count,
          hasReacted: false,
          userReactionId: null,
        };
      }

      // Enrich with current user's reactions from the server payload
      (this.currentUserReactions || []).forEach((reaction) => {
        this.$set(this.userReactions, reaction.emoji, reaction.id);
        if (newSummary[reaction.emoji]) {
          newSummary[reaction.emoji].hasReacted = true;
          newSummary[reaction.emoji].userReactionId = reaction.id;
        }
      });

      this.localReactionSummary = newSummary;
    },
    onReactionAdded(data) {
      const { emoji, reactionId } = data;
      this.$set(this.userReactions, emoji, reactionId);

      if (this.localReactionSummary[emoji]) {
        this.$set(this.localReactionSummary[emoji], 'count', this.localReactionSummary[emoji].count + 1);
        this.$set(this.localReactionSummary[emoji], 'hasReacted', true);
        this.$set(this.localReactionSummary[emoji], 'userReactionId', reactionId);
      } else {
        this.$set(this.localReactionSummary, emoji, {
          count: 1,
          hasReacted: true,
          userReactionId: reactionId,
        });
      }

      this.$emit('reactions-updated', this.getSimpleSummary());
    },
    onReactionRemoved(data) {
      const { emoji } = data;
      this.$delete(this.userReactions, emoji);

      if (this.localReactionSummary[emoji]) {
        const newCount = this.localReactionSummary[emoji].count - 1;
        if (newCount <= 0) {
          this.$delete(this.localReactionSummary, emoji);
        } else {
          this.$set(this.localReactionSummary[emoji], 'count', newCount);
          this.$set(this.localReactionSummary[emoji], 'hasReacted', false);
          this.$set(this.localReactionSummary[emoji], 'userReactionId', null);
        }
      }

      this.$emit('reactions-updated', this.getSimpleSummary());
    },
    getSimpleSummary() {
      const summary = {};
      for (const [emoji, data] of Object.entries(this.localReactionSummary)) {
        summary[emoji] = data.count;
      }
      return summary;
    },
  },
};
</script>
